import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
 const router =new Router({
  routes: [
        {
      path: '/',
      name: 'home',
      component: (resolve) => { console.log("加载主页"); require(['@/views/home'], resolve) }
    },
    {
      path: '/:channel',
      name: 'home',
      component: (resolve) => { console.log("加载主页"); require(['@/views/home'], resolve) }
    }
    // {
    //   path: '/:channel',
    //   name: 'modelHome',
    //   component: (resolve) => { console.log("加载模板页"); require(['@/views/modelHome'], resolve) }
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const { params } = to
 console.log("我要查看日志",to, from)
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js